import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTextEdit"><Path d="M18.5 3.08594L7 14.5859V20.0002H12.4142L23.9142 8.50015L18.5 3.08594Z" fill="currentColor"/><Path d="M1 5.00015V7.00015H10V5.00015H1Z" fill="currentColor"/><Path d="M1 9.00015V11.0002H7V9.00015H1Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextEdit;
